import { ApiModel } from '@composable-api/api.model'
import type { Monetary } from '@sim-api-types/general-data'
import { getFormattedPrice } from '../utils/localization'
import type { GetPriceOptions } from '@simploshop-models/product.model'

interface Attributes {
    [OrdersDiscountModel.ATTR_ID]: number
    [OrdersDiscountModel.ATTR_NAME]: string | null
    [OrdersDiscountModel.ATTR_CODE]: string | null
    [OrdersDiscountModel.ATTR_DISCOUNTED_AMOUNT]: Monetary
    [OrdersDiscountModel.ATTR_DISCOUNTED_TAXED_AMOUNT]: Monetary
    [OrdersDiscountModel.ATTR_IS_FOR_PURCHASE]: boolean
}

export class OrdersDiscountModel extends ApiModel<Attributes> {
    static key = 'OrdersDiscountModel'

    static readonly ATTR_ID = 'id'
    static readonly ATTR_NAME = 'name'
    static readonly ATTR_CODE = 'code'
    static readonly ATTR_DISCOUNTED_AMOUNT = 'discounted_amount'
    static readonly ATTR_DISCOUNTED_TAXED_AMOUNT = 'discounted_taxed_amount'
    static readonly ATTR_IS_FOR_PURCHASE = 'is_for_purchase'


    get id() {
        return this._getAttribute(OrdersDiscountModel.ATTR_ID)
    }
    get name() {
        return this._getAttribute(OrdersDiscountModel.ATTR_NAME)
    }
    get code() {
        return this._getAttribute(OrdersDiscountModel.ATTR_CODE)
    }
    get discountedAmount() {
        return this._getAttribute(OrdersDiscountModel.ATTR_DISCOUNTED_AMOUNT)
    }
    get discountedTaxedAmount() {
        return this._getAttribute(OrdersDiscountModel.ATTR_DISCOUNTED_TAXED_AMOUNT)
    }
    get isForPurchase() {
        return this._getAttribute(OrdersDiscountModel.ATTR_IS_FOR_PURCHASE)
    }

    /**
     * Get the price of the product or its variation (if specified).
     * The price is **WITHOUT discounts**.
     *
     * Consider it as the base price of the product.
     * @see getFormattedPrice
     */
    getPrice(options?: Partial<GetPriceOptions>): Monetary | null {
        return (options?.tax !== false ? this.discountedTaxedAmount : this.discountedAmount) ?? null
    }

    /**
     * Get the formatted price of the product or its variation (if specified).
     * The formatted price is a string with the currency symbol. (e.g. '$10.00')
     *
     * The price is **WITHOUT discounts**.
     *
     * @see getPrice
     */
    getFormattedPrice(options?: Partial<GetPriceOptions>): string | null {
        return getFormattedPrice(this.getPrice(options))
    }
}
